module.exports = __webpack_public_path__ + "static/img/icon-delete.7bf7d04f.png";